export default {
  nav: {
    home: 'Home',
    builder: 'GPAX Builder',
    transformer: 'GPAX Transformer',
    audit: 'GPAX Audit',
    why: 'Why Infoware?',
    contact: 'Contact',
    language: 'English',
  },
  footer: {
    description: 'More than 20 years innovating across Latin America with interoperability and strategic process automation solutions.',
    talk: 'Talk to us',
    products: 'Products',
    company: 'Company',
    contact: 'Contact',
    legal: 'Legal',
    whyInfoware: 'Why Infoware?',
    ourCommitment: 'Our commitment',
    certifications: 'Certifications',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    sla: 'SLA',
    rights: 'All rights reserved.',
    carbonNeutral: 'Carbon Neutral',
  },
};